import { Divider, SxProps, Theme } from '@mui/material';
import { baseColors } from 'utils/constants';

type Props = {
  id?: string;
  type?: string;
  sx?: SxProps<Theme> | undefined;
};

const CustomDivider = ({ type, sx }: Props) => (
  <Divider
    sx={{
      borderColor: baseColors.lineGray,
      borderStyle: type ? type : 'medium',
      ...sx
    }}
  />
);

export default CustomDivider;
